type Props = {
  p25: number | null;
  median: number | null;
  p75: number | null;
  x: (day: number) => number;
  boxBottom: number;
  firstLabelY: number;
  left: number;
  right: number;
};

// 3つの値を別々の高さに置く。四分位点が近い月や180日軸でも文字が重ならない。
export function BoxPlotValueLabels({ p25, median, p75, x, boxBottom, firstLabelY, left, right }: Props) {
  const labels = [
    { name: '25%点', value: p25 },
    { name: '中央値', value: median },
    { name: '75%点', value: p75 },
  ];
  return <g aria-label="箱ひげ図の四分位点と中央値">
    {labels.map(({ name, value }, index) => {
      if (value == null) return null;
      const markX = x(value);
      const labelX = Math.max(left + 55, Math.min(right - 55, markX));
      const labelY = firstLabelY + index * 18;
      return <g key={name}>
        <polyline points={`${markX},${boxBottom + 2} ${markX},${labelY - 12} ${labelX},${labelY - 12}`} fill="none" stroke="#94a3b8" strokeWidth="0.8" />
        <text x={labelX} y={labelY} textAnchor="middle" fontSize="13" fontWeight={name === '中央値' ? '700' : '400'} fill="#334155">{name} {value.toFixed(1)}日</text>
      </g>;
    })}
  </g>;
}
